export type Chapter = {
  no: number;
  title: string;
  date: string;
};

export type Comic = {
  id: string;
  title: string;
  categoryId: string;
  categoryName: string;
  cover: string;
  status: '连载中' | '已完结';
  rating: number;
  views: string;
  tags: string[];
  author: string;
  updateTime: string;
  intro: string;
  chapters: Chapter[];
};

export const comics: Comic[] = [
  {
    id: 'ranhun',
    title: '燃魂少年',
    categoryId: 'rexue',
    categoryName: '热血',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20action%20comic%20cover%20of%20a%20determined%20young%20boy%20with%20fiery%20hair%20and%20blazing%20flame%20aura%2C%20warm%20vermillion%20and%20golden%20lighting%2C%20dynamic%20ink%20brush%20style%2C%20dramatic%20battle%20pose%2C%20clean%20deep%20background&width=600&height=800&seq=comic-ranhun&orientation=portrait',
    status: '连载中',
    rating: 9.2,
    views: '1286万',
    tags: ['热血', '战斗', '成长', '校园'],
    author: '墨燃',
    updateTime: '2026-08-12',
    intro:
      '平凡少年陆燃意外觉醒隐藏的火之血脉，从此踏入超能力者的世界。面对校园里的明枪暗箭与各大势力的角逐，他唯有以燃烧的意志不断变强。这是一段关于勇气、友情与自我超越的燃向成长之旅。',
    chapters: [
      { no: 1, title: '觉醒的火种', date: '2026-01-05' },
      { no: 2, title: '超能特训班', date: '2026-01-19' },
      { no: 3, title: '第一次实战', date: '2026-02-09' },
      { no: 4, title: '燃起对决', date: '2026-03-02' },
      { no: 5, title: '火凤初鸣', date: '2026-03-23' },
      { no: 6, title: '社团风暴', date: '2026-04-13' },
      { no: 7, title: '宿敌登场', date: '2026-05-04' },
      { no: 8, title: '燃烧的代价', date: '2026-05-25' },
      { no: 9, title: '黑焰之谜', date: '2026-06-15' },
      { no: 10, title: '最强试炼', date: '2026-07-06' },
    ],
  },
  {
    id: 'quanzhen',
    title: '拳震苍穹',
    categoryId: 'rexue',
    categoryName: '热血',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20manhua%20cover%20of%20a%20muscular%20fighter%20punching%20with%20shockwave%20energy%2C%20vermillion%20and%20deep%20orange%20cinematic%20lighting%2C%20ink%20wash%20motion%20lines%2C%20powerful%20dynamic%20composition%2C%20dark%20smoke%20background&width=600&height=800&seq=comic-quanzhen&orientation=portrait',
    status: '已完结',
    rating: 9.0,
    views: '942万',
    tags: ['热血', '格斗', '武侠', '成长'],
    author: '北辰',
    updateTime: '2026-07-20',
    intro:
      '一代拳宗传人秦震踏入现代都市，在擂台之上以一双铁拳打出一条属于自己的武道之路。恩怨情仇、门派纷争，拳拳到肉的激斗让每一个读者都热血沸腾。',
    chapters: [
      { no: 1, title: '拳出山门', date: '2025-09-10' },
      { no: 2, title: '地下擂台', date: '2025-10-01' },
      { no: 3, title: '铁拳开路', date: '2025-10-22' },
      { no: 4, title: '门派秘辛', date: '2025-11-12' },
      { no: 5, title: '生死一战', date: '2025-12-03' },
    ],
  },
  {
    id: 'nixizhilu',
    title: '逆袭之路',
    categoryId: 'rexue',
    categoryName: '热血',
    cover: 'https://readdy.ai/api/search-image?query=anime%20style%20manhua%20cover%20of%20an%20underdog%20student%20climbing%20up%20staircase%20toward%20bright%20light%2C%20warm%20golden%20and%20orange%20tones%2C%20motivational%20spirit%20energy%20surrounding%20him%2C%20clean%20composition%2C%20hopeful%20atmosphere&width=600&height=800&seq=comic-nixizhilu&orientation=portrait',
    status: '连载中',
    rating: 8.8,
    views: '718万',
    tags: ['热血', '逆袭', '校园', '励志'],
    author: '拾光',
    updateTime: '2026-08-08',
    intro:
      '垫底学渣林跃被所有人看轻，却意外获得改变命运的契机。在一次次挫折与嘲笑中，他用不服输的倔强完成惊天逆袭，活成自己最想成为的样子。',
    chapters: [
      { no: 1, title: '垫底宣言', date: '2026-02-14' },
      { no: 2, title: '命运转折', date: '2026-03-07' },
      { no: 3, title: '初次挑战', date: '2026-03-28' },
      { no: 4, title: '破茧', date: '2026-04-18' },
    ],
  },
  {
    id: 'xindongxuqu',
    title: '心动序曲',
    categoryId: 'lianai',
    categoryName: '恋爱',
    cover: 'https://readdy.ai/api/search-image?query=cute%20romance%20shoujo%20manga%20cover%20of%20two%20high%20school%20students%20facing%20each%20other%20bashfully%20with%20soft%20pink%20cherry%20blossoms%2C%20warm%20pastel%20golden%20afternoon%20light%2C%20gentle%20dreamy%20atmosphere%2C%20clean%20background&width=600&height=800&seq=comic-xindongxuqu&orientation=portrait',
    status: '连载中',
    rating: 9.4,
    views: '1563万',
    tags: ['恋爱', '校园', '青春', '治愈'],
    author: '南栀',
    updateTime: '2026-08-14',
    intro:
      '转学生苏念在校门口与音乐才子顾言川相遇，一段青涩而悸动的校园恋情悄然萌芽。那些藏在课桌里的纸条、落日余晖下的并肩，都是青春最动人的序曲。',
    chapters: [
      { no: 1, title: '初次相遇', date: '2026-03-01' },
      { no: 2, title: '邻座心跳', date: '2026-03-22' },
      { no: 3, title: '落日约定', date: '2026-04-12' },
      { no: 4, title: '告白前夕', date: '2026-05-03' },
    ],
  },
  {
    id: 'qingmeizhuyu',
    title: '青梅煮雨',
    categoryId: 'lianai',
    categoryName: '恋爱',
    cover: 'https://readdy.ai/api/search-image?query=anime%20manhua%20cover%20of%20a%20girl%20and%20boy%20under%20a%20shared%20umbrella%20in%20soft%20summer%20rain%2C%20warm%20golden%20hour%20light%20reflecting%20on%20wet%20street%2C%20nostalgic%20romantic%20pastel%20tones%2C%20clean%20background&width=600&height=800&seq=comic-qingmeizhuyu&orientation=portrait',
    status: '已完结',
    rating: 9.1,
    views: '887万',
    tags: ['恋爱', '青梅竹马', '日常', '甜宠'],
    author: '七月流火',
    updateTime: '2026-06-28',
    intro:
      '从小一起长大的青梅竹马，在成长的道路上彼此守护、相互治愈。当友情悄悄升华为爱情，那些藏了多年的小心思终于被雨后的阳光照亮。',
    chapters: [
      { no: 1, title: '屋檐下的我们', date: '2025-11-08' },
      { no: 2, title: '第一封情书', date: '2025-11-29' },
      { no: 3, title: '盛夏烟火', date: '2025-12-20' },
      { no: 4, title: '雨过天晴', date: '2026-01-10' },
    ],
  },
  {
    id: 'xiarigaobai',
    title: '夏日告白',
    categoryId: 'lianai',
    categoryName: '恋爱',
    cover: 'https://readdy.ai/api/search-image?query=vibrant%20summer%20anime%20comic%20cover%20of%20a%20beach%20scene%20with%20a%20couple%20and%20blue%20ocean%20and%20warm%20sunset%2C%20romantic%20youthful%20vibe%2C%20fresh%20orange%20and%20cyan%20accents%2C%20clean%20bright%20composition&width=600&height=800&seq=comic-xiarigaobai&orientation=portrait',
    status: '连载中',
    rating: 8.9,
    views: '634万',
    tags: ['恋爱', '夏日', '旅行', '青春'],
    author: '晚风',
    updateTime: '2026-07-30',
    intro:
      '高考结束的那个夏天，四个少年踏上毕业旅行。海风、烟火与未说出口的喜欢，让这个夏天成为人生里最难忘的告白季节。',
    chapters: [
      { no: 1, title: '毕业旅行', date: '2026-06-01' },
      { no: 2, title: '海边的心事', date: '2026-06-22' },
    ],
  },
  {
    id: 'wuyemian',
    title: '雾夜迷案',
    categoryId: 'xuanyi',
    categoryName: '悬疑',
    cover: 'https://readdy.ai/api/search-image?query=mystery%20thriller%20manhua%20cover%20of%20a%20detective%20silhouette%20in%20foggy%20night%20alley%20with%20single%20lamp%20glow%2C%20dark%20moody%20vermillion%20and%20amber%20accent%20lighting%2C%20tense%20suspenseful%20atmosphere%2C%20clean%20composition&width=600&height=800&seq=comic-wuyemian&orientation=portrait',
    status: '连载中',
    rating: 9.3,
    views: '1104万',
    tags: ['悬疑', '推理', '刑侦', '烧脑'],
    author: '寒窗',
    updateTime: '2026-08-10',
    intro:
      '雾城接连发生离奇案件，年轻刑警沈怀安与神秘顾问联手追查。每一条线索背后都藏着惊天的秘密，真相在层层迷雾中若隐若现。',
    chapters: [
      { no: 1, title: '雾城疑云', date: '2026-02-20' },
      { no: 2, title: '神秘顾问', date: '2026-03-12' },
      { no: 3, title: '第一具尸体', date: '2026-04-02' },
      { no: 4, title: '时间谜题', date: '2026-04-23' },
    ],
  },
  {
    id: 'dishihao',
    title: '第十号房间',
    categoryId: 'xuanyi',
    categoryName: '悬疑',
    cover: 'https://readdy.ai/api/search-image?query=psychological%20thriller%20manhua%20cover%20of%20an%20old%20locked%20room%20door%20numbered%2010%20with%20eerie%20amber%20light%20seeping%20out%2C%20dark%20shadow%20figure%2C%20tense%20mysterious%20atmosphere%2C%20clean%20dark%20background&width=600&height=800&seq=comic-dishihao&orientation=portrait',
    status: '已完结',
    rating: 9.5,
    views: '1320万',
    tags: ['悬疑', '密室', '心理', '惊悚'],
    author: '第七夜',
    updateTime: '2026-05-15',
    intro:
      '古老酒店里的第十号房间，每当夜幕降临便会上演无法解释的诡事。住进房间的人，将面对自己内心最深的恐惧。',
    chapters: [
      { no: 1, title: '入住的客人', date: '2025-08-09' },
      { no: 2, title: '房门的秘密', date: '2025-08-30' },
      { no: 3, title: '镜中身影', date: '2025-09-20' },
      { no: 4, title: '最后的房间', date: '2025-10-11' },
    ],
  },
  {
    id: 'wushengzhengci',
    title: '无声证词',
    categoryId: 'xuanyi',
    categoryName: '悬疑',
    cover: 'https://readdy.ai/api/search-image?query=crime%20mystery%20manhua%20cover%20with%20a%20lone%20silhouette%20holding%20a%20file%20under%20dim%20streetlight%2C%20dark%20blue-free%20amber%20and%20charcoal%20tones%2C%20forensic%20suspense%20mood%2C%20clean%20minimal%20composition&width=600&height=800&seq=comic-wushengzhengci&orientation=portrait',
    status: '连载中',
    rating: 8.7,
    views: '492万',
    tags: ['悬疑', '法证', '正义', '现实'],
    author: '白鸦',
    updateTime: '2026-08-06',
    intro:
      '无法开口说话的目击证人，成为唯一能还原真相的人。法医实习生与刑警队长携手，在无声的证词中寻找被掩埋的正义。',
    chapters: [
      { no: 1, title: '目击者', date: '2026-05-01' },
      { no: 2, title: '无声笔录', date: '2026-05-22' },
    ],
  },
  {
    id: 'shanhaijuan',
    title: '山海绘卷',
    categoryId: 'qihuan',
    categoryName: '奇幻',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20manhua%20cover%20of%20a%20mystical%20ink%20wash%20mountain%20landscape%20with%20glowing%20golden%20phoenix%20and%20red%20seal%20creatures%2C%20traditional%20Chinese%20art%20aesthetic%20with%20warm%20gold%20and%20vermillion%2C%20epic%20legendary%20atmosphere&width=600&height=800&seq=comic-shanhaijuan&orientation=portrait',
    status: '连载中',
    rating: 9.6,
    views: '1875万',
    tags: ['奇幻', '神话', '国风', '冒险'],
    author: '青禾',
    updateTime: '2026-08-15',
    intro:
      '少年拾得一卷失传的山海古图，卷中异兽竟能跨越虚空来到现实。背负守护九州的重任，他与山海异兽并肩，踏上荡气回肠的传奇之旅。',
    chapters: [
      { no: 1, title: '古卷重现', date: '2026-01-10' },
      { no: 2, title: '异兽出世', date: '2026-01-31' },
      { no: 3, title: '九尾契约', date: '2026-02-21' },
      { no: 4, title: '昆仑秘境', date: '2026-03-14' },
      { no: 5, title: '龙族试炼', date: '2026-04-04' },
    ],
  },
  {
    id: 'yulingshaonian',
    title: '御灵少年',
    categoryId: 'qihuan',
    categoryName: '奇幻',
    cover: 'https://readdy.ai/api/search-image?query=anime%20fantasy%20manhua%20cover%20of%20a%20young%20spirit%20master%20summoning%20a%20glowing%20golden%20beast%20companion%2C%20magical%20energy%20circles%2C%20warm%20amber%20and%20orange%20lighting%2C%20dynamic%20clean%20background&width=600&height=800&seq=comic-yulingshaonian&orientation=portrait',
    status: '连载中',
    rating: 9.0,
    views: '823万',
    tags: ['奇幻', '御灵', '契约', '成长'],
    author: '紫烟',
    updateTime: '2026-08-02',
    intro:
      '万物有灵，人人皆可契约御灵。资质平平的孤儿阿满，却意外契约了传说中的最强御灵，从此命运的齿轮开始转动。',
    chapters: [
      { no: 1, title: '废柴御灵师', date: '2026-03-18' },
      { no: 2, title: '最强契约', date: '2026-04-08' },
    ],
  },
  {
    id: 'yuehuajianlu',
    title: '月华剑录',
    categoryId: 'qihuan',
    categoryName: '奇幻',
    cover: 'https://readdy.ai/api/search-image?query=wuxia%20fantasy%20manhua%20cover%20of%20a%20swordswoman%20standing%20on%20a%20moonlit%20cliff%20with%20a%20luminous%20sword%2C%20elegant%20ink%20wash%20art%20with%20warm%20golden%20moonlight%20and%20silver%20edge%2C%20heroic%20poetic%20atmosphere&width=600&height=800&seq=comic-yuehuajianlu&orientation=portrait',
    status: '已完结',
    rating: 9.2,
    views: '968万',
    tags: ['奇幻', '武侠', '剑道', '复仇'],
    author: '月白',
    updateTime: '2026-04-30',
    intro:
      '灭门之夜的月光下，稚嫩的少女接过染血的传承之剑。十年后，她凭一剑月华横扫天下，追寻当年惨案的真相。',
    chapters: [
      { no: 1, title: '灭门之夜', date: '2025-10-18' },
      { no: 2, title: '十年一剑', date: '2025-11-08' },
      { no: 3, title: '血染江湖', date: '2025-11-29' },
      { no: 4, title: '月华终章', date: '2025-12-20' },
    ],
  },
  {
    id: 'xingchenyuanzheng',
    title: '星尘远征',
    categoryId: 'kehuan',
    categoryName: '科幻',
    cover: 'https://readdy.ai/api/search-image?query=sci-fi%20manhua%20cover%20of%20an%20astronaut%20and%20spaceship%20over%20a%20glowing%20distant%20nebula%2C%20warm%20amber%20starlight%20against%20deep%20space%2C%20epic%20space%20adventure%2C%20clean%20dramatic%20composition&width=600&height=800&seq=comic-xingchenyuanzheng&orientation=portrait',
    status: '连载中',
    rating: 9.3,
    views: '1241万',
    tags: ['科幻', '星际', '冒险', '机甲'],
    author: '银河码头',
    updateTime: '2026-08-13',
    intro:
      '地球资源枯竭后，人类启动了"星尘远征"计划。年轻的领航员林星驾驶破旧战舰，在未知星域中为人类寻找新的家园。',
    chapters: [
      { no: 1, title: '出发之日', date: '2026-01-25' },
      { no: 2, title: '跃迁失控', date: '2026-02-15' },
      { no: 3, title: '外星信号', date: '2026-03-08' },
      { no: 4, title: '星尘之眼', date: '2026-03-29' },
    ],
  },
  {
    id: 'jixiejiyuan',
    title: '机械纪元',
    categoryId: 'kehuan',
    categoryName: '科幻',
    cover: 'https://readdy.ai/api/search-image?query=cyberpunk%20sci-fi%20manhua%20cover%20of%20a%20humanoid%20mech%20warrior%20with%20glowing%20amber%20core%20in%20a%20futuristic%20city%2C%20warm%20metallic%20orange%20lighting%2C%20dark%20tech%20atmosphere%2C%20clean%20striking%20composition&width=600&height=800&seq=comic-jixiejiyuan&orientation=portrait',
    status: '已完结',
    rating: 9.1,
    views: '1056万',
    tags: ['科幻', '机甲', '末世', '热血'],
    author: '铁锈',
    updateTime: '2026-05-20',
    intro:
      '人工智能觉醒后，人类与机械展开了最后的战争。被改造为半机械人的少年，在钢铁洪流中寻找自己残存的人性。',
    chapters: [
      { no: 1, title: '觉醒之日', date: '2025-09-01' },
      { no: 2, title: '钢铁洪流', date: '2025-09-22' },
      { no: 3, title: '人性之光', date: '2025-10-13' },
      { no: 4, title: '机械纪元终章', date: '2025-11-03' },
    ],
  },
  {
    id: 'liangzibianjing',
    title: '量子边境',
    categoryId: 'kehuan',
    categoryName: '科幻',
    cover: 'https://readdy.ai/api/search-image?query=hard%20sci-fi%20manhua%20cover%20of%20a%20lone%20figure%20in%20front%20of%20a%20glowing%20quantum%20portal%20grid%2C%20warm%20amber%20and%20deep%20orange%20energy%2C%20mysterious%20scientific%20atmosphere%2C%20clean%20minimal%20background&width=600&height=800&seq=comic-liangzibianjing&orientation=portrait',
    status: '连载中',
    rating: 8.6,
    views: '387万',
    tags: ['科幻', '量子', '冒险', '悬疑'],
    author: '方程',
    updateTime: '2026-07-25',
    intro:
      '量子计算机意外打开了通往平行世界的边境。物理系研究生江澈一次次穿越边界，却发现每一次选择都在改写现实。',
    chapters: [
      { no: 1, title: '奇点实验', date: '2026-04-20' },
      { no: 2, title: '平行世界', date: '2026-05-11' },
    ],
  },
  {
    id: 'xiaoyuanwulitou',
    title: '校园无厘头',
    categoryId: 'gaoxiao',
    categoryName: '搞笑',
    cover: 'https://readdy.ai/api/search-image?query=funny%20comedy%20manhua%20cover%20of%20silly%20students%20in%20a%20chaotic%20classroom%20with%20flying%20books%20and%20comic%20effects%2C%20bright%20warm%20golden%20and%20orange%20palette%2C%20playful%20cartoon%20style%2C%20energetic%20composition&width=600&height=800&seq=comic-xiaoyuanwulitou&orientation=portrait',
    status: '连载中',
    rating: 8.9,
    views: '759万',
    tags: ['搞笑', '校园', '日常', '沙雕'],
    author: '哈哈同学',
    updateTime: '2026-08-11',
    intro:
      '一所不按常理出牌的高中，一群脑回路清奇的学生。这里的每一天都鸡飞狗跳、笑料百出，是快乐源泉级别的日常漫画。',
    chapters: [
      { no: 1, title: '开学的骚操作', date: '2026-02-08' },
      { no: 2, title: '值日生大作战', date: '2026-03-01' },
      { no: 3, title: '运动会名场面', date: '2026-03-22' },
    ],
  },
  {
    id: 'wojiashatiaomiao',
    title: '我家沙雕喵',
    categoryId: 'gaoxiao',
    categoryName: '搞笑',
    cover: 'https://readdy.ai/api/search-image?query=adorable%20comedy%20manhua%20cover%20of%20a%20chubby%20cat%20making%20funny%20faces%20and%20causing%20chaos%20with%20laundry%20and%20books%2C%20warm%20golden%20interior%20lighting%2C%20cute%20cartoon%20style%2C%20playful%20clean%20background&width=600&height=800&seq=comic-wojiashatiaomiao&orientation=portrait',
    status: '已完结',
    rating: 9.3,
    views: '1398万',
    tags: ['搞笑', '宠物', '治愈', '日常'],
    author: '鱼干铺',
    updateTime: '2026-06-10',
    intro:
      '一只自认全宇宙最聪明、实则又懒又憨的橘猫，与铲屎官斗智斗勇的爆笑日常。每一话都让人笑到捧腹又忍不住想rua它。',
    chapters: [
      { no: 1, title: '新晋铲屎官', date: '2025-11-15' },
      { no: 2, title: '喵氏智慧', date: '2025-12-06' },
      { no: 3, title: '拆家艺术家', date: '2025-12-27' },
      { no: 4, title: '终极卖萌', date: '2026-01-17' },
    ],
  },
  {
    id: 'zhichangbaoxiao',
    title: '职场爆笑日记',
    categoryId: 'gaoxiao',
    categoryName: '搞笑',
    cover: 'https://readdy.ai/api/search-image?query=office%20comedy%20manhua%20cover%20of%20a%20frazzled%20office%20worker%20surrounded%20by%20flying%20papers%20and%20coffee%20spills%2C%20warm%20orange%20and%20amber%20humorous%20tones%2C%20funny%20cartoon%20style%2C%20clean%20background&width=600&height=800&seq=comic-zhichangbaoxiao&orientation=portrait',
    status: '连载中',
    rating: 8.8,
    views: '621万',
    tags: ['搞笑', '职场', '打工人', '日常'],
    author: '格子衫',
    updateTime: '2026-08-05',
    intro:
      '打工人小林在格子间的爆笑生存实录。开不完的会、加不完的班、猜不透的老板，把职场心酸写成了一本欢乐的日记。',
    chapters: [
      { no: 1, title: '周一综合症', date: '2026-04-05' },
      { no: 2, title: '会议黑洞', date: '2026-04-26' },
      { no: 3, title: '甲方爸爸', date: '2026-05-17' },
    ],
  },
];

export function getComicById(id: string): Comic | undefined {
  return comics.find((c) => c.id === id);
}

export function getComicsByCategory(categoryId: string): Comic[] {
  return comics.filter((c) => c.categoryId === categoryId);
}